import { authorizedApiClient } from "../config";
import {
  DocumentFeedback,
  SignalDocument,
  SignalDocumentListResponse,
  SkillEffectivenessReport,
  SubmitFeedbackPayload,
} from "./signalDocumentsEndpoints.interface";

export const getSignalDocument = async ({
  workspace_id,
  document_id,
}: {
  workspace_id: string;
  document_id: string;
}) =>
  authorizedApiClient.get<SignalDocument>(
    `/${workspace_id}/signal-documents/${document_id}`,
  );

export const listSignalDocuments = async ({
  workspace_id,
  entity_id,
  signal_run_id,
  automation_id,
  health_model_key,
  signal_type,
}: {
  workspace_id: string;
  entity_id?: string;
  signal_run_id?: string;
  automation_id?: string;
  health_model_key?: string;
  signal_type?: string;
}) =>
  authorizedApiClient.get<SignalDocumentListResponse>(
    `/${workspace_id}/signal-documents`,
    {
      params: {
        ...(entity_id && { entity_id }),
        ...(signal_run_id && { signal_run_id }),
        ...(automation_id && { automation_id }),
        ...(health_model_key && { health_model_key }),
        ...(signal_type && { signal_type }),
      },
    },
  );

export const getDocumentVersions = async ({
  workspace_id,
  document_id,
}: {
  workspace_id: string;
  document_id: string;
}) =>
  authorizedApiClient.get<SignalDocumentListResponse>(
    `/${workspace_id}/signal-documents/${document_id}/versions`,
  );

export const submitDocumentFeedback = async ({
  workspace_id,
  document_id,
  feedback_type,
  comment,
}: SubmitFeedbackPayload) =>
  authorizedApiClient.post<DocumentFeedback>(
    `/${workspace_id}/signal-documents/${document_id}/feedback`,
    { feedback_type, comment },
  );

export const listDocumentFeedback = async ({
  workspace_id,
  document_id,
}: {
  workspace_id: string;
  document_id: string;
}) =>
  authorizedApiClient.get<DocumentFeedback[]>(
    `/${workspace_id}/signal-documents/${document_id}/feedback`,
  );

export const getSkillEffectiveness = async ({
  workspace_id,
  skill_id,
}: {
  workspace_id: string;
  skill_id: string;
}) =>
  authorizedApiClient.get<SkillEffectivenessReport>(
    `/${workspace_id}/skill-effectiveness/${skill_id}`,
  );
